import { render, staticRenderFns } from "./signaturePersonalDetails.vue?vue&type=template&id=8dd4349c&scoped=true&"
import script from "./signaturePersonalDetails.vue?vue&type=script&lang=js&"
export * from "./signaturePersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./signaturePersonalDetails.vue?vue&type=style&index=0&id=8dd4349c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4349c",
  null
  
)

export default component.exports